import { ref, reactive, computed } from 'vue'
import { defineStore } from 'pinia'

// import Ajax from '@utils/ajax'

import Category from '@model/category'

export const useCategory = defineStore('category', () => {
    // const isLoading = ref(false)

    // Fetch all categories
    const categories = ref([])
    const getCategories = computed(() => categories.value)
    const fetchCategories = async () => {
        categories.value = await Category.init().all()
    }
    // const findCategoryById = (category_id) => {
    //     return categories.value.find(category => category.category_id == category_id) || {}
    // }


    // Fetch single category
    // const category = ref({})
    // const getCategory = computed(() => category.value)
    const model = (category_id = null) => {
        return new Category({ category_id: category_id })
    }
    // const fetchCategory = async (category_id = null) => {
    //     return category.value = await model(category_id).get() ||[]
    // }

    // export
    return {
        // isLoading,
        getCategories,
        fetchCategories,
        // getCategory,
        // fetchCategory,
        // findCategoryById,
        model,

        // filterCategory,
        // bulkDelete
    }
})
